import { http } from '@/utils/http';
import qs from 'qs';

const baseUrl = '/vote/2020project/2020hotpotlive/controller.php';

const getUnionId = (code: any) => {
  const qsData = qs.stringify({ code });
  return http.post('/vote/public/controller.php?enews=hotunionid', qsData);
};

// 送礼物
interface ISendGift {
  foodname: string;
  nickname: string;
  unionid: string;
  headimg: string;
}
const sendGiftApi = (data: ISendGift, liveType: string | number) => {
  const qsData = qs.stringify(data);
  return http.post(`${baseUrl}?enews=add-food&liveType=${liveType}`, qsData);
};
// 获取直播基础信息
const getBaseInfo = (liveType: number | string) => {
  return http.get(`${baseUrl}?enews=base-info`, {
    params: {
      liveType,
    },
  });
};
// 获取总的礼物类型
const getGiftStore = () => {
  return http.get(`${baseUrl}?enews=food-list`, {
    params: {
      liveType: 1,
    },
  });
};
// 检查是否重复注册
interface IHasAlreadyGottenSauce {
  unionid: string;
}
const hasAlreadyGottenSauce = (data: IHasAlreadyGottenSauce) => {
  return http.post(
    `${baseUrl}?enews=if-add-msg-live&liveType=1`,
    qs.stringify(data),
  );
};
// 领火锅底料
interface IRegister {
  unionid: string;
  nickname?: string;
  name?: string;
  phone?: string | number;
  company?: string;
  address?: string;
}
const registerGetSauce = (data: IRegister) => {
  const qsData = qs.stringify(data);
  return http.post(`${baseUrl}?enews=add-userInfo-live&liveType=1`, qsData);
};

// 注册xmpp用户
interface IGenXmppUser {
  unionid: string;
}
const genXmppUser = (data: IGenXmppUser, liveType: number | string) => {
  return http.post(
    `${baseUrl}?enews=register&liveType=${liveType}`,
    qs.stringify(data),
  );
};

// 发送评论
interface ISubmitComment {
  unionid: string;
  nickname: string;
  headImg: string;
  content: string;
}
const submitComment = (data: ISubmitComment, liveType: string | number) => {
  return http.post(
    `${baseUrl}?enews=comment-save&liveType=${liveType}`,
    qs.stringify(data),
  );
};

// 分页获取评论
interface IHistoryComments {
  id?: string | number;
  page: number;
  liveType: string | number;
}
const getHistoryComments = (data: IHistoryComments) => {
  return http.get(`${baseUrl}?enews=comment-list-id`, {
    params: data,
  });
};

export {
  getUnionId,
  sendGiftApi,
  getBaseInfo,
  getGiftStore,
  registerGetSauce,
  hasAlreadyGottenSauce,
  genXmppUser,
  submitComment,
  getHistoryComments,
};
